/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ events: NonNullable<unknown> }} Intakeprocessedone2Inputs */

const en_intakeprocessedone2 = /** @type {(inputs: Intakeprocessedone2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 file processed · ${i?.events} extracted`)
};

const pt_intakeprocessedone2 = /** @type {(inputs: Intakeprocessedone2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 ficheiro processado · ${i?.events} extraídos`)
};

/**
* | output |
* | --- |
* | "1 file processed · {events} extracted" |
*
* @param {Intakeprocessedone2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakeprocessedone2 = /** @type {((inputs: Intakeprocessedone2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakeprocessedone2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakeprocessedone2(inputs)
	return pt_intakeprocessedone2(inputs)
});
export { intakeprocessedone2 as "intakeProcessedOne" }